<style scoped></style>
<template>
  <div>
    <div class="my-2 text-right">
      <button
        type="button"
        @click="toggleView('EDITOR', $event)"
        class="px-3 py-2 font-medium text-sm rounded-md"
        :class="{
          'text-gray-500 hover:text-gray-700': this.view == 'CODE',
          'bg-indigo-100 text-indigo-700 ': this.view != 'CODE',
        }"
      >
        Editor
      </button>
      <button
        type="button"
        @click="toggleView('CODE', $event)"
        class="px-3 py-2 font-medium text-sm rounded-md"
        :class="{
          'text-gray-500 hover:text-gray-700': this.view == 'EDITOR',
          'bg-indigo-100 text-indigo-700 ': this.view != 'EDITOR',
        }"
      >
        Code
      </button>
    </div>
    <div v-if="this.view == 'EDITOR'">
      <ul class="divide-y divide-gray-200">
        <li
          v-for="(field, i) in fields"
          v-bind:key="i"
          class="py-4"
          :id="field.id"
          :element="field.element"
          :type="field.type"
          :name="field.name"
          :value="field.value"
          draggable
          @dragstart="dragStart(i, $event)"
          @dragover="dragOver($event)"
          @drop="drop(i, $event)"
        >
          <FieldItem
            :fields="fields"
            :field="field"
            @ondelete="onDelete(i, $event)"
            @onsave="onSave(i, $event)"
          />
        </li>
      </ul>
      <div class="text-right">
        <button
          class="btn-secondary mt-2"
          @click="
            (e) => {
              e.preventDefault();
              addRow();
            }
          "
        >
          {{ $t('editor.add_field') }}
        </button>
      </div>
    </div>
    <textarea
      v-if="this.view == 'CODE'"
      name="fields"
      v-model="code"
      class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
      cols="40"
      rows="10"
    />
    <p v-if="error" class="mt-2 text-sm text-red-600">{{ error }}</p>
    <input type="hidden" name="fields" :value="JSON.stringify(this.fields)" />
  </div>
</template>
<script>
import FieldItem from './FieldItem';

export default {
  name: 'EditorComponent',
  components: {
    FieldItem,
  },
  data() {
    return {
      view: 'EDITOR',
      fields: this.initialFields,
      error: '',
    };
  },
  methods: {
    toggleView(view, e) {
      e.preventDefault();
      this.view = view;
    },
    dragStart(sourceIndex, e) {
      e.dataTransfer.clearData();
      e.dataTransfer.setData('text/plain', sourceIndex);
    },
    dragOver(e) {
      e.preventDefault(); // prevent default to allow drop action
    },
    drop(targetIndex, e) {
      const sourceIndex = e.dataTransfer.getData('text/plain');

      const removedFields = this.fields.splice(sourceIndex, 1);
      this.fields.splice(targetIndex, 0, removedFields[0]);
    },
    onDelete(index) {
      this.fields.splice(index, 1);
    },
    addRow() {
      const field = {
        element: 'field',
        type: '',
        id: 'nieuw_veld',
      };
      // Define 'label' as a reactive property
      Object.defineProperty(field, 'label', {
        get: () => this.$t('editor.new_field'),
      });
      this.fields.push(field);
    },
    onSave(index, value) {
      this.$set(this.fields, index, value);
    },
  },
  computed: {
    code: {
      get: function () {
        return JSON.stringify(this.fields);
      },
      set: function (newValue) {
        this.error = '';

        try {
          this.fields = JSON.parse(newValue);
        } catch (e) {
          this.error = this.$t('editor.invalid_json');
        }
      },
    },
  },
  props: {
    initialFields: Array,
  },
};
</script>
